import React from 'react';
import './shop.scss'
import './shopList.scss'

// フェッチ時表示用
const fetchingShopList = [
  { id: 'dunmmy1', name: '', type: null, address: '' },
  { id: 'dunmmy2', name: '', type: null, address: '' },
  { id: 'dunmmy3', name: '', type: null, address: '' }
]

/**
 * 店舗一覧および詳細
 */
class ShopList extends React.Component {
  constructor(props) {
    super(props);
    this.shopWrapperEl = React.createRef();
    this.handleShopClick = this.handleShopClick.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentDidUpdate() {
    const node = this.shopWrapperEl.current;
    const selected = node.querySelector('.shopList__item--selected')
    if (selected) {      
      // 親ボックスからの相対的な位置
      // console.log('selected.offsetTop', selected.offsetTop);
      // 現在のボックス内のスクロール量を取得
      // console.log('node.scrollTop', node.scrollTop);

      node.scrollTop = selected.offsetTop;
    } else {
      node.scrollTop = 0;
    }
  }

  handleBackClick() {
    const { selectedShop, shopClickAction } = this.props;
    // 表示店舗idクリア
    shopClickAction(selectedShop.id, null);
  }

  handleShopClick(shop) {
    const { shopClickAction } = this.props;

    const hasDetail = shop.isOfficial
    shopClickAction(shop.id, hasDetail);
  }

  renderShop() {
    const { shopList, selectedShop, visibleDistance } = this.props;

    const shop = shopList.find((element, index, array) => {
      return (element.id === selectedShop.id);
    });

    return (
      <div className="shop">
        <div className="shop__back" onClick={() => this.handleBackClick()}> &lt; 一覧へ戻る</div>
        <div className="shop__body">
          <div className="shop__name">
            {shop.name}<span className={`shop__badge shop__badge--${shop.type.value}`}>{shop.type.label}</span>
          </div>
          {shop.detail && shop.detail.mapImage && (
            <div className="shop__image">
              <img src={shop.detail.mapImage} alt="" />
            </div>
          )}
          <div className="shop__address">
            {shop.address}<br />
            <span className="shop__tel">
              <i className="shop__icon shop__icon--tel">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"/></svg>
              </i>{shop.tel}
            </span>
          </div>
          {shop.detail && shop.detail.siteUrl && (
            <div className="shop__url">
              <div className="shop__heading">
                店舗URL
                <i className="shop__icon shop__icon--url">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"/></svg>
                </i>
              </div>
              <a href={shop.detail.siteUrl} target="_blank" rel="noopener noreferrer">{shop.detail.siteUrl}</a>
            </div>
          )}
          {shop.detail && shop.detail.businessHour && (
            <div className="shop__businessHour">
              <div className="shop__heading">営業時間</div>
              {shop.detail.businessHour}
            </div>
          )}
          {shop.detail && shop.detail.parking && (
            <div className="shop__parking">
              <div className="shop__heading">駐車場</div>
              {shop.detail.parking}
            </div>
          )}
        </div>
        <div className="shop__footer">
          <div className="shop__heading">受けられるサービス</div>
          <div className="shop__service">
            <div className="shop__heading2">対応可能サービス</div>
            <div className="shop__tags">
              {shop.detail && shop.detail.service1List.map(item => {
                return (
                  <div className="shop__tag" key={item.value}>{item.label}</div>
                )
              })}
            </div>
          </div>
          <div className="shop__service">
            <div className="shop__heading2">実機展示</div>
            <div className="shop__tags">
              {shop.detail && shop.detail.service2List.map(item => {
                return (
                  <div className="shop__tag" key={item.value}>{item.label}</div>
                )
              })}
            </div>
          </div>
          <div className="shop__service">
            <div className="shop__heading2">当日渡し</div>
            <div className="shop__tags">
              {shop.detail && shop.detail.service3List.map(item => {
                return (
                  <div className="shop__tag" key={item.value}>{item.label}</div>
                )
              })}
            </div>
          </div>
        </div>
        {visibleDistance && shop.distance && (
          <div className="shop__distance">
            <i className="shop__icon shop__icon--distance">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"/></svg>
            </i>
            {shop.distance} km
          </div>
        )}
      </div>
    );
  }

  getListItemClass(shopId, isOfficial) {
    const { selectedShop } = this.props;

    let listItemClass = 'shopList__item';

    if (isOfficial) {
      listItemClass += ' shopList__item--clickable';
    }

    if (selectedShop.id === shopId) {
      listItemClass += ' shopList__item--selected';
    }

    return listItemClass;
  }

  renderList() {
    const { shopList, visibleDistance, isFetching } = this.props;

    // データ取得中は読み込み中のデータを入れておく
    let dispShopList = isFetching ? fetchingShopList : shopList

    return (
      <div className="shopList">
        {dispShopList.map((shop) => {
          return (
            <div key={shop.id} className={this.getListItemClass(shop.id, shop.isOfficial)} onClick={() => this.handleShopClick(shop)}>
              <div className={isFetching ? 'shop shop--isFetching' : 'shop'}>
                <div className="shop__body">
                  <div className="shop__name">
                    {shop.name}
                    {shop.type && (
                      <span className={`shop__badge shop__badge--${shop.type.value}`}>{shop.type.label}</span>
                    )}
                  </div>
                  <div className="shop__address">
                    {shop.address}<br />
                    {shop.tel && (
                      <span className="shop__tel">
                        <i className="shop__icon shop__icon--tel">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"/></svg>
                        </i>{shop.tel}
                      </span>
                    )}
                  </div>
                </div>
                {visibleDistance && shop.distance && (
                  <div className="shop__distance">
                    <i className="shop__icon shop__icon--distance">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"/></svg>
                    </i>
                    {shop.distance} km
                  </div>
                )}
              </div>
            </div>
          )
        })}
        {dispShopList.length === 0 && (
          <div className="shopList__nodata">データが取得できませんでした。</div>
        )}
      </div>
    )
  }

  render() {
    const { selectedShop } = this.props;
    return (
      <div className='shopWrapper' ref={this.shopWrapperEl}>
        { selectedShop.hasDetail ? this.renderShop() : this.renderList() }
      </div>
    )
  }
}

export default ShopList;